<template>
    <el-container class="is-vertical">
        <el-card shadow="never">
            <el-row slot="header" type="flex" align="middle" justify="space-between">
                <strong>转载掘金文章</strong>
                <el-button type="primary" @click="reprintJuejin" :loading="loading">一键转载</el-button>
            </el-row>
            <el-form ref="juejin" :model="juejinForm">
                <el-form-item prop="target" required>
                    <el-input placeholder="请输入掘金文章地址" v-model="juejinForm.target">
                        <template slot="prepend">掘金地址</template>
                    </el-input>
                </el-form-item>
            </el-form>
        </el-card>
    </el-container>
</template>

<script>
export default {
    name: "page-reprint",
    data() {
        return {
            loading: false,
            juejinForm: {
                target: ""
            }
        };
    },
    methods: {
        reprintJuejin() {
            this.$refs["juejin"].validate(valid => {
                if (valid) {
                    this.loading = true;
                    this.axios.post("/admin/reprintJJ", this.juejinForm).then(
                        () => {
                            this.loading = false;
                            this.$message.success("转载成功！");
                        },
                        () => {
                            this.loading = false;
                            this.$message.error("转载失败！");
                        }
                    );
                }
            });
        }
    }
};
</script>

<style>
</style>